var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82568 1.99316V4.16038",
    stroke: "#292D32",
    strokeWidth: 1.30033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6055 1.99316V4.16038",
    stroke: "#292D32",
    strokeWidth: 1.30033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5752 7.1156H14.8561",
    stroke: "#292D32",
    strokeWidth: 1.30033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2171 6.68904V12.8295C15.2171 14.9967 14.1335 16.4415 11.6051 16.4415H5.82589C3.29747 16.4415 2.21387 14.9967 2.21387 12.8295V6.68904C2.21387 4.52183 3.29747 3.07703 5.82589 3.07703H11.6051C14.1335 3.07703 15.2171 4.52183 15.2171 6.68904Z",
    stroke: "#292D32",
    strokeWidth: 1.30033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3851 10.4457H11.3916",
    stroke: "#292D32",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3851 12.6129H11.3916",
    stroke: "#292D32",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71221 10.4457H8.7187",
    stroke: "#292D32",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71221 12.6129H8.7187",
    stroke: "#292D32",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03839 10.4457H6.04487",
    stroke: "#292D32",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03839 12.6129H6.04487",
    stroke: "#292D32",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.819d2629d68350df155b188866cce1ec.svg";
export { ForwardRef as ReactComponent };